import { FormEvent } from "react";
import { FormControl, FormLabel, FormControlProps } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { Switch } from "src/components/common/switch/switch";
import { EnumCountryKey } from "src/types/common-enum";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { ISearch } from "../search.types";
import { handleIsInvestableInCountry } from "../store/actions";
import { useSearchStore } from "../store/search-store";

interface IProps extends ISearch {
    size?: string;
    trackHeight?: string;
    styles?: FormControlProps;
}

export const InvestableInCountrySwitch = ({ onSearch, size, styles }: IProps) => {
    const { country } = useRouterLocale();
    const { isAtInvestable, isChInvestable } = useSearchStore();
    const { t } = useTranslation("extended-search");

    const onChange = (event: FormEvent<HTMLInputElement>) => {
        const isChecked = event.currentTarget.checked;
        handleIsInvestableInCountry({ isChecked, country, onSearch });
    };

    switch (country) {
        case EnumCountryKey.AT:
            return (
                <FormControl display="inline-flex" alignItems="center" width="auto" {...styles}>
                    <Switch size={size} isChecked={isAtInvestable} onChange={onChange} />
                    <FormLabel mb="0" ml={1} fontWeight="inherit" fontSize="inherit">
                        {t("labels.investable-in-at")}
                    </FormLabel>
                </FormControl>
            );

        case EnumCountryKey.CH:
            return (
                <FormControl display="inline-flex" alignItems="center" width="auto" {...styles}>
                    <Switch size={size} isChecked={isChInvestable} onChange={onChange} />
                    <FormLabel mb="0" ml={1} fontWeight="inherit" fontSize="inherit">
                        {t("labels.investable-in-ch")}
                    </FormLabel>
                </FormControl>
            );

        default:
            return null;
    }
};
